/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/ARMAuthenticationDetailsHeader" />
import React = require("react");
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { css } from "VSS/Platform/Layout";
import { Link } from "VSSUI/Link";


export function ARMAuthenticationDetailsHeader(): JSX.Element {
    const appRegistrationLink = "https://go.microsoft.com/fwlink/?LinkID=623000";
    return (<React.Fragment>
        <span role="heading" aria-level={4} className={css("service-endpoint-section-headers", "arm-auth-header")}>{Resources.AuthenticationHeader}</span>
        <FormatComponent format={Resources.WIFAuthenticationHeaderDescription} className="secondary-text ">
            <Link href={appRegistrationLink}>{Resources.AppRegistrationLinkLabel}</Link>
        </FormatComponent>
    </React.Fragment>);
}
